import React, { useState } from "react";
import PaginateList from "../../../utils/PaginateList";
import { useTranslation } from "react-i18next";
import * as ReliefServices from "../../../../services/ReliefServices";

import {
  checkBootstrapSizeBreak,
  SIZES,
} from "../../../../utils/device/checkDevice";

import { getDateFormatTimeZone } from "../../../../utils/formats";
import { ButtonAction, Icon } from "./reliefList.styled";
import { useRelief } from "../hook/useRelief";
import { Can } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";

const StopHistoryListContainer = ({ filters, sortBy }) => {
  const { t } = useTranslation();
  const deviceSize = checkBootstrapSizeBreak();
  const [forceRefresh, setForceRefresh] = useState(false);
  const refresh = () => {
    setForceRefresh(true);
  };

  const { showCheckInRelief, reliefObservations } = useRelief(refresh);

  const columns = [
    {
      header: t("forms.relief.table.head.turnInit"),
      accessorKey: "turnData.initDate",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.relief.table.head.turnEnd"),
      accessorKey: "turnData.endDate",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.relief.table.head.userCreated"),
      accessorFn: (row) => row?.dataUser?.email ?? "-",
      id: "dataUserEmail",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.relief.table.head.nextTurn"),
      accessorFn: (row) => row?.nextTurnData?.dataUser?.email ?? "-",
      id: "nextTurnUserEmail",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.relief.table.head.read"),
      accessorKey: "read",
      cell: (info) => (info.getValue() ? "Sí" : "No"),
    },
    {
      header: t("forms.relief.table.head.createdAt"),
      accessorKey: "createdAt",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.relief.table.head.updatedAt"),
      accessorKey: "updatedAt",
      cell: (info) =>
        getDateFormatTimeZone(info.getValue(), "DD-MM-yyyy HH:mm"),
      size: 200,
    },
    {
      header: t("forms.relief.table.head.userModified"),
      accessorFn: (row) => row?.dataUserModified?.email ?? " - ",
      id: "dataUserModifiedEmail",
      cell: (info) => info.getValue(),
    },
    {
      header: t("forms.relief.table.head.actions"),
      accessorKey: "ac",
      cell: (info) => renderAction(info.row.original),
    },
  ];

  const renderAction = (data) => {
    return (
      <>
        <div className="dropdown text-center">
          <ButtonAction
            onClick={() => showObservations(data.uuid)}
            title={t("forms.turnHistory.labels.delete")}
          >
            <Icon className="fa-solid fa-eye"></Icon>
          </ButtonAction>
          <Can do={USER_PERMISSIONS.EDIT_RELIEF}>
            <ButtonAction
              onClick={() => editRelief(data)}
              title={t("forms.order.labels.edit")}
            >
              <Icon className="fa-regular fa-pen-to-square"></Icon>
            </ButtonAction>
          </Can>
        </div>
      </>
    );
  };

  const editRelief = async (data) => {
    reliefObservations({
      edit: true,
      uuid: data.uuid,
      observations: data.observations,
    });
  };

  const showObservations = (uuid) => {
    showCheckInRelief(false, uuid);
  };

  const listData = async (filter) => {
    if (sortBy) {
      filter.sort = sortBy;
    } else {
      filter.sort = "-createdAt";
    }
    const result = await ReliefServices.listFilter(filter);
    return result;
  };

  const hideColumn = {};
  let resize = null;

  if (deviceSize < SIZES.md) {
    hideColumn.itemCode = false;
    resize = false;
  } else if (deviceSize === SIZES.md) {
    hideColumn.itemCode = false;
  }

  return (
    <>
      <PaginateList
        refresh={forceRefresh}
        filters={filters}
        columns={columns}
        toList={listData}
        hideColum={hideColumn}
        resize={resize}
        resetRefresh={() => setForceRefresh(false)}
      ></PaginateList>
    </>
  );
};

export default StopHistoryListContainer;
